import {Trans} from "@lingui/react/macro";
import * as React from "react";

const strings = {
    createdBy: (name: React.ReactNode): React.ReactElement => {
        return (
            <Trans context="@ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.Created by a single author">
                Created by {name}.
            </Trans>
        );
    },
    createdByMany: (nameList: Array<React.ReactNode>): React.ReactElement => {
        return (
            <Trans context="@ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.Created by multiple authors">
                Created by {nameList}.
            </Trans>
        );
    },
} as const;

export default strings;
